import { useState, useCallback } from 'react';

const useSteps = (stepsCount) => {
  const [activeStep, setActiveStep] = useState(0);
  const isLastStep = activeStep === stepsCount - 1;

  const handleNext = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  }, []);

  const handleBack = useCallback(() => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  }, []);

  const handleReset = useCallback(() => {
    setActiveStep(0);
  }, []);

  return {
    activeStep,
    handleNext,
    handleBack,
    handleReset,
    isLastStep,
  };
};

export { useSteps };
